import * as R from 'remeda';
import { AnnotationListSideload } from '@rossum/api-client/annotations';
import { SchemaColumn } from '@rossum/api-client/shared';
import { getAnnotationId } from '../../lib/url';
import { getColumnField } from './utils';

const groupContentByAnnotationId = (
  columns: AnnotationListSideload['content'] | undefined
) => {
  return R.groupBy(columns ?? [], datapoint =>
    getAnnotationId(datapoint.url ?? '')
  );
};

export const appendSchemaColumns = <T extends { id: number }>(
  annotation: T,
  rawSchemaColumns: SchemaColumn[],
  sideloadContent: AnnotationListSideload['content'],
  loadedAnnotationIds: number[]
) => {
  const content = groupContentByAnnotationId(sideloadContent);

  const schemaColumnsDataTypesAndScoreThreshold = R.reduce(
    rawSchemaColumns,
    (
      acc: Record<string, Pick<SchemaColumn, 'dataType' | 'scoreThreshold'>>,
      item
    ) => {
      const key = item.schemaId;
      acc[key] = {
        dataType: item.dataType,
        scoreThreshold: item.scoreThreshold,
      };
      return acc;
    },
    {}
  );

  const schemaColumns = R.fromEntries(
    (content[annotation.id] || []).map(datapoint => {
      return [
        getColumnField({
          columnType: 'schema',
          field: datapoint.schemaId ?? 'uknown schema id',
          dataType: datapoint.schemaId
            ? schemaColumnsDataTypesAndScoreThreshold[datapoint.schemaId]
                ?.dataType
            : undefined,
        }),
        {
          annotationId: annotation.id,
          datapointId: datapoint.id,
          value: datapoint.content?.value,
          validationSources: datapoint.validationSources,
          confidenceScore: datapoint.content?.rirConfidence,
          scoreTreshold: datapoint.schemaId
            ? schemaColumnsDataTypesAndScoreThreshold[datapoint.schemaId]
                ?.scoreThreshold
            : undefined,
        },
      ];
    })
  );

  return {
    ...annotation,
    ...schemaColumns,
    datapointsReady: loadedAnnotationIds.includes(annotation.id),
  };
};
